import MuiLink from '@mui/material/Link'
import MarkdownTextarea from '../components/MarkdownTextarea'
import React, {useState} from 'react'
import MarkdownDisplay from '../components/MarkdownDisplay'
import {Paper} from '@mui/material'

const newlineTextInitial = `A single newline won't show up
as a newline in markdown.

---

To get a newline in markdown you

need a full empty line.

---

Multiple consecutive line breaks can be achieved using non-breaking spaces and empty lines:

&nbsp;

Something

&nbsp;

&nbsp;

like

&nbsp;

&nbsp;

this.`

const listsTextInitial = `This is an unordered list:

- Item 1
- Item 2
    - Sub-item 2.1
    - Sub-item 2.2
- Item 3

This is an ordered list:

1. Item 1
2. Item 2
    1. Sub-item 2.1
    2. Sub-item 2.2
3. Item 3`

const miscTextInitial = `Quotes look like this:

>"We cannot solve our problems with the same thinking we used when we created them." - Albert Einstein

Horizontal rule:

---

# Heading 1
## Heading 2
### Heading 3
#### Heading 4
##### Heading 5

&nbsp;

This is how use **bold text**.

This is how you *italicize text*.

This text uses ~~strikethrough~~

Emoji: :+1:`

const codeSnippetsTextInitial = `Javascript:
\`\`\`javascript
console.log('hello world')
\`\`\`

JSON:
\`\`\`json
{
  "firstName": "John",
  "lastName": "Doe"
}
\`\`\``

const mathTextInitial = `Lift($L$) can be determined by Lift Coefficient ($C_L$) like the following
equation.

$$
L = \\frac{1}{2} \\rho v^2 S C_L
$$`

export default function MarkdownHelp() {
  const [newlineText, setNewlineText] = useState<string>(newlineTextInitial)
  const [listsText, setListsText] = useState<string>(listsTextInitial)
  const [miscText, setMiscText] = useState<string>(miscTextInitial)
  const [codeSnippetsText, setCodeSnippetsText] = useState<string>(codeSnippetsTextInitial)
  const [mathText, setMathText] = useState<string>(mathTextInitial)
  
  return (
    <>
      <h1>Markdown Help</h1>
      
      <h2>What is Markdown?</h2>
      <p>Markdown provides the ability to apply formatting to text. You can read more about it here: <MuiLink href="https://en.wikipedia.org/wiki/Markdown">https://en.wikipedia.org/wiki/Markdown</MuiLink>.</p>
      
      <h2>Try It Out</h2>
      
      <p>Empty lines</p>
      <MarkdownTextarea value={newlineText} onChange={value => setNewlineText(value)}/>
      <Paper sx={{flexGrow: 1, p: 1, minHeight: "150px"}}>
        <MarkdownDisplay value={newlineText}/>
      </Paper>
      
      <p>Lists</p>
      <MarkdownTextarea value={listsText} onChange={value => setListsText(value)}/>
      <Paper sx={{flexGrow: 1, p: 1, minHeight: "150px"}}>
        <MarkdownDisplay value={listsText}/>
      </Paper>
      
      <p>Misc Examples</p>
      <MarkdownTextarea value={miscText} onChange={value => setMiscText(value)}/>
      <Paper sx={{flexGrow: 1, p: 1, minHeight: "150px"}}>
        <MarkdownDisplay value={miscText}/>
      </Paper>
      
      <p>Code Snippets</p>
      <MarkdownTextarea value={codeSnippetsText} onChange={value => setCodeSnippetsText(value)}/>
      <Paper sx={{flexGrow: 1, p: 1, minHeight: "150px"}}>
        <MarkdownDisplay value={codeSnippetsText}/>
      </Paper>
      
      <p>Math notation</p>
      <MarkdownTextarea value={mathText} onChange={value => setMathText(value)}/>
      <Paper sx={{flexGrow: 1, p: 1, minHeight: "150px"}}>
        <MarkdownDisplay value={mathText}/>
      </Paper>
    </>
  )
}
